import Heading from 'unsubscribe-ui/components/core/typography/Heading';
import { jsx as _jsx } from "react/jsx-runtime";
export const CompanyName = ({
  company
}) => {
  if (!company || !company.companyName) return null;
  return /*#__PURE__*/_jsx(Heading, {
    variant: "heading-600",
    children: company.companyName
  });
};